/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-arrowbig-left': {
    width: 30,
    height: 8,
    viewBox: '0 0 30 8',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3.32 7.738L.146 4.556a.501.501 0 010-.707L3.319.667a.498.498 0 01.705 0 .501.501 0 010 .707L1.703 3.703H30v1H1.703L4.024 7.03a.501.501 0 010 .707.498.498 0 01-.705 0z" _fill="#fff"/>'
  }
})
